module.exports = __webpack_public_path__ + "static/img/jidi.612deed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jidi.jpg
// module id = y7BX
// module chunks = 1